export default "__VITE_ASSET__DCVPhYfg__"